import { configure } from '@/util/container';
import registerResize from '@/util/resize';
import { VUE } from '..';

export default configure(async (get) => void registerResize(await get(VUE)));
